module.exports = __webpack_public_path__ + "static/img/主视觉KV设计-平面合成主视觉.d32913c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/主视觉KV设计-平面合成主视觉.png
// module id = kZyd
// module chunks = 1